import Lookup from 'src/componentes/select2';

const CasasDecimaisLookup = ({ ...rest }) => (
  <Lookup
    labelKey="descricao"
    valueKey="id"
    options={[
      {
        id: 999,
        descricao: '0',
      },
      {
        id: 1,
        descricao: '1',
      },
      {
        id: 2,
        descricao: '2',
      },
      {
        id: 3,
        descricao: '3',
      },
      {
        id: 4,
        descricao: '4',
      },
      {
        id: 5,
        descricao: '5',
      },
    ]}
    {...rest}
  />
);

export default CasasDecimaisLookup;
